
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2085_39589)"}},[_c('path',{attrs:{"d":"M25.495 11.332c0-4.69-3.811-8.5-8.5-8.5-4.69 0-8.5 3.81-8.5 8.5 0 6.375 8.5 15.583 8.5 15.583s8.5-9.208 8.5-15.583zm-11.334 0a2.842 2.842 0 012.834-2.833 2.842 2.842 0 012.833 2.833 2.833 2.833 0 01-2.833 2.833 2.842 2.842 0 01-2.834-2.833zm-7.083 17v2.833h19.833v-2.833H7.078z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2085_39589"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h34v34H0z"}})])])])
          )
        }
      }
    